export const CUSTOM_DATA_SOURCE_PREFIX = "Eigene Angabe";

export interface DataSource {
  id: string;
  title: string;
}

export interface DataSourceQualityMapping {
  dataQualityLetter: string;
  dataQualityValue: number;
}

export const ENERGY_DATA_SOURCE_LIST: (DataSource & DataSourceQualityMapping)[] = [
  { id: "1", title: "Netzbetreiber", dataQualityLetter: "A", dataQualityValue: 1 },
  { id: "2", title: "Energieversorger", dataQualityLetter: "A", dataQualityValue: 1 },
  { id: "3", title: "Schornsteinfegerdaten", dataQualityLetter: "B", dataQualityValue: 0.5 },
  { id: "4", title: "Förderprogramme", dataQualityLetter: "B", dataQualityValue: 0.5 },
  { id: "5", title: "Regionaldatenbank Statistisches Landesamt", dataQualityLetter: "B", dataQualityValue: 0.5 },
  { id: "8", title: "ÖPNV-Unternehmen", dataQualityLetter: "A", dataQualityValue: 1 },
  { id: "9", title: CUSTOM_DATA_SOURCE_PREFIX, dataQualityLetter: "D", dataQualityValue: 0 },
];

const DATA_SOURCE_QUALITY_MAPPING: Record<string, DataSourceQualityMapping> = Object.fromEntries([
  ...ENERGY_DATA_SOURCE_LIST.map((dataSource) => [
    dataSource.title,
    { dataQualityLetter: dataSource.dataQualityLetter, dataQualityValue: dataSource.dataQualityValue },
  ]),
  ["ifeu auf Basis DB AG", { dataQualityLetter: "C", dataQualityValue: 0.25 }],
]);

export const KNOWN_CONSUMPTION_DATA_SOURCES = new Set(ENERGY_DATA_SOURCE_LIST.map((dataSource) => dataSource.title));

export const getDataQualityForDataSource = (dataSource: string): number | null => {
  const mapping = DATA_SOURCE_QUALITY_MAPPING[dataSource];
  return mapping?.dataQualityValue ?? null;
};

export const hasAutomaticDataQuality = (dataSource: string): boolean => {
  return dataSource in DATA_SOURCE_QUALITY_MAPPING;
};

export const getDataQualityLetterForDataSource = (dataSource: string): string | null => {
  const mapping = DATA_SOURCE_QUALITY_MAPPING[dataSource];
  return mapping?.dataQualityLetter ?? null;
};
